import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

export interface DashboardData {
  newUsersToday: number;
  newPlayersToday: number;
  countOfPlayersUnderMe: number;
  sumCashInYesterday: number;
  sumCashoutYesterday: number;
  sumCashInLast30Days: number;
  sumCashoutLast30Days: number;
  sumCashInToday: number;
  sumCashoutToday: number;
  sumCashInLast7Days: number;
  sumCashoutLast7Days: number;
}

const GET_DASHBOARD = gql`
  query GetDashboard($environmentID: Int) {
    getDashboard(environmentID: $environmentID) {
      newUsersToday
      newPlayersToday
      countOfPlayersUnderMe
      sumCashInYesterday
      sumCashoutYesterday
      sumCashInLast30Days
      sumCashoutLast30Days
      sumCashInToday
      sumCashoutToday
      sumCashInLast7Days
      sumCashoutLast7Days
    }
  }
`;

export const getDashboardData = async (environmentID?: number): Promise<DashboardData> => {
  try {
    const { data } = await apolloClient.query<{
      getDashboard: DashboardData;
    }>({
      query: GET_DASHBOARD,
      fetchPolicy: 'network-only',
      variables: {
        environmentID: environmentID || undefined,
      },
    });
    return data.getDashboard;
  } catch (error) {
    console.error('❌ Error fetching dashboard data:', error);
    throw error;
  }
};
